import { Outlet, ScrollRestoration } from "react-router";

import { SiteHeader } from "@/components/layout/site-header";
import { Toaster } from "@/components/ui/sonner";

export function RootLayout() {
  return (
    <div className="bg-background text-foreground flex min-h-svh flex-col">
      <SiteHeader />
      <main className="mx-auto w-full max-w-6xl flex-1 px-4 py-8">
        <Outlet />
      </main>
      {/* The API host used to be printed here, to make a misconfigured build
          obvious -- the base URL is baked in at build time. That is a developer's
          concern shown to every student, and it is already covered where it
          matters: an unreachable API produces "Cannot reach the API at <url>"
          from lib/api.ts, at the point of failure. */}
      <footer className="text-muted-foreground border-t px-4 py-6 text-center text-xs">
        <p>
          <a
            href="https://ai4ce.github.io/"
            className="hover:text-foreground underline-offset-4 hover:underline"
            target="_blank"
            rel="noreferrer"
          >
            AI4CE Lab
          </a>
          {" · New York University"}
        </p>
      </footer>
      <Toaster position="bottom-right" richColors />
      <ScrollRestoration />
    </div>
  );
}
